module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_vm._t("right")], 2)]), _vm._v(" "), _c('div', [_vm._t("content")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d864af4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shelf.vue
// module id = 280
// module chunks = 0 1 2 3 4 6 7 8 9 10 13 14 16 17 18 19 20 22 23 24 25 27